export default "{\n    \"label\": \"Instalación\",\n    \"placeholder\": \"Seleccione instalación\",\n    \"noOptions\": \"No se encontraron instalaciones\"\n}"